export default {"src":"/_next/static/media/checkmark--filled.1e3d3efa.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};